import {
  reportsCampaignsPath,
  reportsDashboardPath,
  reportsDataSearchPath,
  reportsJaqiAiPath,
  reportsMetabaseAccountPath,
  reportsMetabaseCampaignPath,
} from 'app/navigation/paths'

export interface Page {
  name: string
  path: string
}
export const PATH: Record<string, string> = {
  Dashboard: reportsDashboardPath,
  Campaigns: reportsCampaignsPath,
  DataSearch: reportsDataSearchPath,
  JaqiAi: reportsJaqiAiPath,
  MetabaseAccount: reportsMetabaseAccountPath,
  MetabaseCampaign: reportsMetabaseCampaignPath,
}

export const PAGES: Page[] = [
  {
    name: 'Live Dashboard',
    path: PATH.Dashboard,
  },
  {
    name: 'Campaigns',
    path: PATH.Campaigns,
  },
  {
    name: 'Data Search',
    path: PATH.DataSearch,
  },
  {
    name: 'Jaqi AI',
    path: PATH.JaqiAi,
  },
  {
    name: 'Account Overview',
    path: PATH.MetabaseAccount,
  },
  {
    name: 'Campaign Overview',
    path: PATH.MetabaseCampaign,
  },
]

export const THOUGHTSPOT_ROUTES = [
  PATH.Dashboard,
  PATH.Campaigns,
  PATH.DataSearch,
  PATH.JaqiAi,
] as const

export const DASHBOARD_NAV_ITEMS = [
  { key: 'accounts', title: 'Account Overview', path: PATH.Dashboard },
  { key: 'campaigns', title: 'Campaign Overview', path: PATH.Campaigns },
  { key: 'data-search', title: 'Data Search', path: PATH.DataSearch },
  { key: 'jaqi', title: 'Jaqi', path: PATH.JaqiAi },
  {
    key: 'account',
    title: 'Account Overview',
    path: PATH.MetabaseAccount,
  },
  {
    key: 'campaign',
    title: 'Campaign Overview',
    path: PATH.MetabaseCampaign,
  },
] as const
